<template>
    <div>
      <div class="row">
        <div class="col-12 checkout-form-header">
          <span class="checkout-form-title">{{ t('preview.order.coupon.redeem') }}</span>
        </div>
        <div class="col-12 form-group customerCouponRedeemInput">
          <input type="text" name="coupon_code" class="form-control"
                 :value="couponCode"
                 @input="updateCoupon($event.target.value)"
                 :placeholder="t('preview.order.coupon.code')">
        </div>
        <div v-show="isCouponSuccess" class="col-12 coupon-code-alert">
          <div class="alert alert-sm alert-success text-center"
               id="js-coupon-code-text-success-msg">{{t('checkout.coupon.redeemed')}}</div>
        </div>
        <div v-show="isCouponError" class="col-12 coupon-code-alert">
          <div class="alert alert-sm alert-warning-secondary text-center"
               id="js-coupon-code-text-error-msg">{{t('checkout.coupon.invalid')}}</div>
        </div>
        <div v-show="isCouponLoading" class="col-12 coupon-code-alert">
          <div class="alert alert-sm alert-info text-center"
               id="js-coupon-code-text-loading-msg"
          >{{t('checkout.coupon.loading')}} <i class="fa fa-circle-o-notch spinner-icon fa-spin"></i></div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CheckoutCoupon',
  props: ['couponCode'],
  watch: {
    coupon (val) {
      this.couponCode = val
    }
  },
  data () {
    return {
      couponLoading: false,
      debounceTimer: null
    }
  },
  computed: {
    ...mapGetters(['previewOrderData']),
    isCouponError () {
      return (this.coupon.length > 0 && this.previewOrderData.couponDiscount === 0) && !this.isCouponLoading
    },
    isCouponSuccess () {
      return (this.coupon.length > 0 && this.previewOrderData.couponDiscount > 0) && !this.isCouponLoading
    },
    isCouponLoading () {
      return this.couponLoading
    },
    coupon () {
      return this.previewOrderData.couponCode
    }
  },
  methods: {
    ...mapActions(['checkCoupon']),
    updateCoupon (newCoupon) {
      this.couponCode = newCoupon
      this.couponLoading = true
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.checkCoupon(newCoupon).then(() => {
          this.couponLoading = false
        }).catch(() => {
          this.couponLoading = false
        })
      }, 1000)
    }
  }
}
</script>

<style scoped>
.spinner-icon {
  display: inline-flex;
  width: 15px;
  height: 15px;
  margin: 0 0 0 0.5rem;
  justify-content: center;
  vertical-align: middle;
  align-items: center;
}
</style>
